import React, { useRef, useState, useEffect } from "react";
import useOnClickOutside from "use-onclickoutside";

const MultiSelectNew = (props) => {
  const contentRef = useRef(null);
  const [filter, setFilter] = useState("");
  const [optionsA, setOptionsA] = useState(props.options);
  const [isHovering, setIsHovering] = useState(props.isHovering);

  const handleMouseOver = (e) => {
    e.preventDefault();
    setIsHovering(true);
  };

  const handleMouseOut = (e) => {
    e.preventDefault();
    setIsHovering(false);
  };

  const handleOptionToggle = (option) => {
    const isSelected = props.selectedOptions.includes(option.value);
    let newSelectedOptions = [];

    if (isSelected) {
      if (option.value === "all") {
        newSelectedOptions = [];
      } else {
        newSelectedOptions = props.selectedOptions.filter(
          (selectedOption) => selectedOption !== option.value
        );
      }
    } else {
      if (option.value === "all") {
        optionsA.map((el) => {
          newSelectedOptions.push(el.value);
        });
      } else {
        newSelectedOptions = [...props.selectedOptions, option.value];
      }
    }

    props.setSelectedOptions(newSelectedOptions);
    props.onChange(newSelectedOptions);
  };

  const changeFilter = (e) => {
    e.preventDefault();
    setFilter(e.target.value);
    if (e.target.value.length === 0) {
      setOptionsA(props.options);
    } else {
      setOptionsA(
        props.options.filter((el) =>
          el.label
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const getSelected = () => {
    if (props.selectedOptions.length === 0) {
      return "Wybierz...";
    }
    if (props.selectedOptions.filter((e) => e === "all").length > 0) {
      return "Wszystkie opcje";
    }
    var retValue = "";
    props.selectedOptions.map((e) => {
      retValue = retValue + (e === "none" ? "Brak danych" : e) + ", ";
    });

    return retValue;
  };

  const handleMouseLeave = () => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  };

  const getHovering = () => {
    if (props.type === "lawyer") {
      return props.isHoveringLaywer;
    }
    if (props.type === "court") {
      return props.isHoveringCourt;
    }
    if (props.type === "bank") {
      return props.isHoveringBank;
    }
    if (props.type === "status") {
      return props.isHoveringStatus;
    }
    if (props.type === "type") {
      return props.isHoveringType;
    }
    if (props.type === "source") {
      return props.isHoveringSource;
    }
  };

  return (
    <div>
      {!props.isHovering ? (
        <>
          <div
            className="searchInput"
            id={props.id}
            style={{
              overflow: "scroll",
              overflowX: "hidden",
              height: "5vh",
              display: "flex",
              alignItems: "center",
              border: "1px solid black",
              marginTop: "1vh",
              borderRadius: "15px",
              boxShadow: "0px 15px 24px -17px rgba(66, 68, 90, 1)",
              padding: "0px 10px",
            }}
            onClick={() => props.setIsHovering(!props.isHovering)}
          >
            <p id={props.id} className="msValue">
              {getSelected()}
            </p>
          </div>
        </>
      ) : (
        ""
      )}
      {props.isHovering ? (
        <>
          <div className="searchInput" id={props.id} className="multiSelInp">
            <div id={props.id} style={{ display: "flex", gap: "10px" }}>
              <input
                id={props.id}
                style={{
                  marginBottom: "15px",
                  height: "3vh",
                  borderRadius: "5px",
                  width: "90%",
                }}
                type="text"
                value={filter}
                onChange={changeFilter}
              />
              <button
                id={props.id}
                style={{
                  height: "30px",
                  marginTop: "1vh",
                  cursor: "pointer",
                  fontSize: "1vw",
                }}
                className="closeClientButton"
                onClick={() => props.setIsHovering(false)}
              >
                X
              </button>{" "}
            </div>

            {optionsA.map((option) => (
              <label id={props.id} className="checkFlex" key={option.value}>
                <input
                  id={props.id}
                  className="checkInput"
                  type="checkbox"
                  checked={props.selectedOptions.includes(option.value)}
                  onChange={() => handleOptionToggle(option)}
                />
                {option.label}
              </label>
            ))}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default MultiSelectNew;
